import { NebulaPro } from "@nebulajs/pro";
import "@nebulajs/pro/dist/style.css";

import { NebulaWeb, setTableConfig, setColumnConfig } from "@nebulajs/web";
import "@nebulajs/web/dist/style.css";

import { format } from "date-fns";
import { createApp } from "vue";
import Index from "./index.vue";
import access from "./plugins/access";
import http from "./plugins/http";
import router from "./plugins/router";

setTableConfig({
  pagination: { pageSize: 20 },
});

setColumnConfig({
  type: ({ type, row, column }) => {
    if (type === "datetime") {
      const value = row.record[column.data.field];
      if (!value) return "";
      return format(value, "yyyy-MM-dd HH:mm:ss");
    }
    const [dateValue, formatString] = type.split("|");
    if (dateValue === "datetime" && formatString) {
      const value = row.record[column.data.field];
      if (!value) return "";
      return format(value, formatString);
    }
  },
});

const app = createApp(Index);
app.use(router);
app.use(http);
app.use(access);
app.use(NebulaWeb);
app.use(NebulaPro);
app.mount("#app");
